import { shortText } from '../utilities/index.js';

document.addEventListener('DOMContentLoaded', function() {
    // News Row that pulls in WP Rest APIs on homepage
    const news_id = document.getElementById("home-news-row");
    if (news_id) {

        // load in WP apis to create a flex grid
        fetch(wpObj.api + "/press-releases-type?per_page=1&_embed")
            .then(response => response.json())
            .then(data => {
                data.forEach(item => {
                    let ft_image;

                    if (item._embedded['wp:featuredmedia']) {
                        ft_image = item._embedded['wp:featuredmedia']['0'].source_url;
                    } else {
                        ft_image = "https://via.placeholder.com/150";
                    }

                    const element = document.createElement('div');
                    element.innerHTML = `<li class='cards__item news-article-card' data-src='News Article' data-url='${item.link}'><div class='card'><a href='${item.link}'><span class='sr-only'>${shortText(item.title.rendered)}</span><div role='img' class='card__image' style='background-image: url(${ft_image});'></div></a><div class='card__content'><div class='caption' role='button' tabindex='0'><p>${shortText(item.title.rendered)}</p><div class='excerpt'>${shortText(item.excerpt.rendered)}</div></div><a href='${item.link}' class='link-btm'>Read More <span class='sr-only'>${shortText(item.title.rendered)}</span><span><img src='${wpObj.theme_url}/assets/images/icons/small-right-grey.svg' role='presentation' alt='Decorative Arrow' class='right-arrow'></span></a></div></div></li>`;
                    news_id.appendChild(element.firstChild);
                });

                document.querySelectorAll(".news-article-card").forEach(card => {
                    card.addEventListener('click', function() {
                        window.location = this.getAttribute('data-url');
                    });
                });
            })
            .catch(error => console.error('Error fetching press releases:', error));

        // Blog Posts
        fetch(wpObj.api + "/posts?per_page=2&_embed")
            .then(response => response.json())
            .then(data => {
                data.forEach(item => {
                    let ft_image;
                    if (item._embedded['wp:featuredmedia']) {
                        ft_image = item._embedded['wp:featuredmedia']['0'].media_details.sizes['news-api-crop'].source_url;
                    } else {
                        ft_image = "https://via.placeholder.com/150";
                    }

                    const element = document.createElement('div');
                    element.innerHTML = `<li class='cards__item blog-card' data-src='Blog Posts' data-url='${item.link}'><div class='card'><a href='${item.link}' target='_blank'><span class='sr-only'>${shortText(item.title.rendered)}</span><div role='img' class='card__image' style='background-image: url(${ft_image});'></div><div class='card__content'><div class='caption' role='button' tabindex='0'><p>${shortText(item.title.rendered)}</p><div class='excerpt'>${shortText(item.excerpt.rendered)}</div></div><span class='link-btm' target='_blank'>Read More<span><img src='${wpObj.theme_url}/assets/images/icons/small-right-grey.svg' role='presentation' role='presentation' alt='Decorative Arrow' class='right-arrow'></span></span></div></a></div></li>`;
                    news_id.appendChild(element.firstChild);
                });
            })
            .catch(error => console.error('Error fetching blog posts:', error));

        // ACF field on home page for a static UF article
        fetch(wpObj.api + "/resource/?per_page=1&_embed&content.protected=false&_fields=id,title,link,content.protected,_links,excerpt")
            .then(response => response.json())
            .then(data => {
                data.forEach(item => {
                    let ft_image;
                    if (item._embedded['wp:featuredmedia']) {
                        ft_image = item._embedded['wp:featuredmedia']['0'].source_url;
                    } else {
                        ft_image = "https://via.placeholder.com/150";
                    }

                    const element = document.createElement('div');
                    element.innerHTML = `<li class='cards__item blog-card' data-src='Ressource' data-url='${item.link}'><div class='card'><a href='${item.link}' target='_blank'><span class='sr-only'>${shortText(item.title.rendered)}</span><div role='img' class='card__image' style='background-image: url(${ft_image});'></div><div class='card__content'><div class='caption' role='button' tabindex='0'><p>${shortText(item.title.rendered)}</p><div class='excerpt'>${shortText(item.excerpt.rendered)}</div></div><span class='link-btm' target='_blank'>Read More<span><img src='${wpObj.theme_url}/assets/images/icons/small-right-grey.svg' role='presentation' role='presentation' alt='Decorative Arrow' class='right-arrow'></span></span></div></a></div></li>`;
                    news_id.appendChild(element.firstChild);
                });

                document.querySelectorAll(".uf-card").forEach(card => {
                    card.addEventListener('click', function() {
                        window.open(this.getAttribute('data-url'));
                    });
                });
            })
            .catch(error => console.error('Error fetching resources:', error));
    }
});